import { createContext, useContext, useState } from 'react';
import { IdentifiedProfileResponse } from '../../api/DTO/IdentifiedProfileResponse';
import { ProfileResponse } from '../../api/DTO/ProfileResponse';
import { ShortlistedProfile } from '../../api/DTO/ShortlistedProfile';

export type SelectedProfile = Pick<IdentifiedProfileResponse, 'id' | 'searchCriteriaScores'> &
    Pick<ProfileResponse, 'name' | 'location' | 'about' | 'experience' | 'education' | 'url' | 'languages'> & {
        emailSentCount?: ShortlistedProfile['emailSentCount'];
    };

export interface AiSearchProfilePopoutContextType {
    open: boolean;
    selectedProfile?: SelectedProfile;
    openProfilePopout: (profile: SelectedProfile) => void;
    closeProfilePopout: () => void;
    hideEmailThreads: boolean;
}

export const AiSearchProfilePopoutContext = createContext<AiSearchProfilePopoutContextType>(undefined!);

export const useAiSearchProfilePopoutContextProvider = (
    { hideEmailThreads } = { hideEmailThreads: false },
): AiSearchProfilePopoutContextType => {
    const [open, setOpen] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState<SelectedProfile>();

    const openProfilePopout = (profile: SelectedProfile) => {
        setSelectedProfile(profile);
        setOpen(true);
    };

    const closeProfilePopout = () => setOpen(false);

    return { open, selectedProfile, hideEmailThreads, openProfilePopout, closeProfilePopout };
};

export const useAiSearchProfilePopoutContext = () => {
    const context = useContext(AiSearchProfilePopoutContext);

    if (!context) {
        throw new Error('useAiSearchProfilePopoutContext must be used inside AiSearchProfilePopoutContextProvider');
    }

    return context;
};
